<template>
  <b-row>
    <b-col md="6">
      <b-form-group
        id="connection-type-group"
        :label="$_.capitalize($t('connection-type'))"
        label-for="connection-type">
        <b-select id="connection-type" v-model="selected" :options="options"/>
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
import BreadcrumbsManager from '@/mixins/BreadcrumbsManager';

export default {
  name: 'PLCConnectionSettings',
  data() {
    return {
      selected: 'cloud',
      options: [
        {
          value: 'cloud',
          text: this.$t('cloud-connection'),
        },
        {
          value: 'local',
          text: this.$t('local-connection'),
          disabled: true,
        },
      ],
      breadcrumbs: [
        {
          text: this.$t('plc-connection-settings'),
        },
      ],
    };
  },
  mixins: [
    BreadcrumbsManager,
  ],
};
</script>

<style scoped></style>
